import { SR_API_ACTION_RENTER_GET_VIEWED_LISTINGS } from 'api/actionTypes';

export default async function getViewedListings({ state, apiClient }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_RENTER_GET_VIEWED_LISTINGS,
    state: state,
    onSuccess(viewedListingIds) {
      state.set(['listingsMapView', 'viewedListings'], viewedListingIds);
    },
  });
}
